import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const PaymentSuccess: React.FC = () => {
  return (
    <div className="container" style={{ textAlign: 'center', paddingTop: '60px' }}>
      <div
        style={{
          background: '#E8F5E9',
          borderRadius: '12px',
          padding: '40px',
          maxWidth: '500px',
          margin: '0 auto',
        }}
      >
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>&#10003;</div>
        <h1 style={{ color: '#2E7D32', marginBottom: '10px' }}>Payment Successful!</h1>
        <p style={{ color: '#757575', marginBottom: '30px' }}>
          Your payment has been processed. It may take a moment for your payment status to update.
        </p>
        <Link to="/payments" className="btn btn-primary">
          View My Payments
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
